module.exports = __webpack_public_path__ + "media/images/landings/promotion_3/img_flow-06-2845226ef1ab8fba00e72a4650cb563a.png";